export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-18 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20curated%20digital%20content%20platform%20with%20warm%20golden%20lighting%2C%20sophisticated%20editorial%20workspace%2C%20clean%20minimal%20aesthetic%2C%20professional%20atmosphere%2C%20soft%20natural%20light%2C%20warm%20amber%20accents%2C%20refined%20composition&width=900&height=675&seq=about-main&orientation=landscape"
                  alt="探花系列平台介绍"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-primary-100/50 rounded-2xl -z-10"></div>
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-accent-100/40 rounded-2xl -z-10"></div>
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-information-line"></i>
              关于平台
            </div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-4">
              关于探花系列
            </h2>
            <div className="space-y-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                探花系列是一个专注于精品内容聚合与资源分享的综合性平台，致力于为探花迷提供最优质的一站式内容发现体验。
                平台汇聚了探花大神合集、探花一区专区、探花91社区精选以及探花探花推荐等多元内容板块。
              </p>
              <p>
                我们的编辑团队每日从社区中甄选探花精选内容，按照探花大神作品质量、探花一区热门程度及用户口碑进行分级推荐，
                确保每一条推送到用户面前的内容都经过精心筛选。同时，平台持续优化内容索引和分类体系，
                让探花迷能够快速定位到心仪的探花精品资源。
              </p>
              <p>
                无论你是寻找探花大神合集的新粉丝，还是关注探花91社区的资深用户，探花系列平台都将为你提供最贴心的浏览体验。
              </p>
            </div>

            <div className="mt-6 flex flex-wrap gap-4">
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-checkbox-circle-line text-primary-500"></i>
                <span>每日更新精选内容</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-checkbox-circle-line text-primary-500"></i>
                <span>多维度内容索引</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-checkbox-circle-line text-primary-500"></i>
                <span>社区口碑驱动推荐</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}